<div class="sliders grid-container">
    <div class="flex-row col-gap">
        <clr-range-container [clrRangeHasProgress]="true">
            <label>Size</label>
            <input
                clrRange
                name="size-range"
                class="slider"
                type="range"
                max="20"
                min="1"
                [ngModel]="pointSize$ | async"
                (ngModelChange)="setPointSize($event)"
            />
        </clr-range-container>
    </div>
    <div class="flex-row col-gap">
        <clr-range-container [clrRangeHasProgress]="true">
            <label>Opacity</label>
            <input
                clrRange
                name="opacity-range"
                class="slider"
                type="range"
                max="10"
                min="0"
                [ngModel]="pointOpacity$ | async"
                (ngModelChange)="setPointOpacity($event)"
            />
        </clr-range-container>
    </div>
    <div *ngIf="isUnsupervisedSelection">
        <cds-form-group>
            <div class="flex-row col-gap" *ngrxLet="resolution$ as resolution">
                <cds-range>
                    <label>Resolution</label>
                    <input
                        name="opacity-range"
                        class="slider"
                        type="range"
                        step="2"
                        max="10"
                        min="2"
                        [ngModel]="resolution"
                        (ngModelChange)="setResolution($event)"
                    />
                    <cds-control-message>{{
                        resolution === 10 ? '1.0' : resolution / 10
                    }}</cds-control-message>
                </cds-range>
            </div>
        </cds-form-group>
    </div>
</div>
<div class="grid-container">
    <div class="grid-container selected-selections" *ngrxLet="selectionSize$ as selectionSize">
        <span *ngIf="(selectionSize ?? 0) > 0">{{ selectionSize$ | async }} selected</span>
    </div>
    <div class="grid-container selected-selections">
        <cds-button action="outline" size="sm" (click)="openAddPropertiesDialog()"
            >Add properties</cds-button
        >
    </div>
    <div class="grid-container selected-selections" *ngrxLet="lassoType$ as lassoType">
        <cds-button action="outline" size="sm" (click)="setLassoType()"
            ><cds-icon *ngIf="lassoType === 'freeform'" shape="pencil"></cds-icon>
            <cds-icon
                *ngIf="lassoType !== 'freeform'"
                shape="axis-chart"
                flip="horizontal"
            ></cds-icon
        ></cds-button>
    </div>
    <div class="cds-button-group">
        <ng-container *ngrxLet="selectionMode$ as mode">
            <cds-button
                class="selectionModeBtn"
                size="icon"
                [action]="mode == SelectionModeEnum.Add ? 'solid' : 'outline'"
                (click)="setSelectionModeAdd()"
            >
                <cds-icon shape="plus"></cds-icon>
            </cds-button>
            <cds-button
                class="selectionModeBtn"
                size="icon"
                [action]="mode == SelectionModeEnum.Subtract ? 'solid' : 'outline'"
                (click)="setSelectionModeSubtract()"
            >
                <cds-icon shape="minus"></cds-icon>
            </cds-button>
            <cds-button
                class="selectionModeBtn"
                action="outline"
                size="icon"
                (click)="clearSelection()"
            >
                <cds-icon shape="refresh"></cds-icon>
            </cds-button>
        </ng-container>
    </div>
</div>
